class Animations {
  constructor() {}

  initializeAnimations = () => {
    const animatedElements = document.querySelectorAll("[data-animate]");
    console.log("animatedElements", animatedElements);

    animatedElements.forEach((el) => {
      const animations = el.dataset.animate.split(",");
      const speed = el.dataset.animateSpeed + "s";

      if (el.dataset.animateMode !== "blocks")
        this.configItem(el, { animations, speed });
      else
        el.childNodes.forEach((child, index) => {
          child.style.transitionDelay = `${index * 0.5}s`;
          this.configItem(child, { animations, speed });
        });
      window.IntersectionHandler.addListener(el, () => {
        if (el.dataset.animateMode !== "blocks")
          return el.classList.add("animateStart");
        el.childNodes.forEach((child) => child.classList.add("animateStart"));
      });
    });
  };

  configItem = (el, { animations, speed }) => {
    el.classList.add("animate");
    el.classList.add(...animations);
    el.style.transitionDuration = speed;
  };
}

window.Animations = new Animations();
window.Animations.initializeAnimations();
